/*
*
* File JS componente Hero Section
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import Swiper from 'swiper';
import { Navigation, Pagination, A11y, EffectFade, Autoplay } from 'swiper/modules';

Swiper.use([Navigation, Pagination, A11y, EffectFade, Autoplay]);


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './hero-homepage.scss';

//--------------------------------------------------------------------//
const heroHomepage = () => {
    let slider = document.querySelectorAll('.hero-homepage .swiper-container');
    if(!slider.length) return;
    
    slider.forEach(el => {
        
        let arrowPrev = el.querySelector('.swiper-button-prev');
        let arrowNext = el.querySelector('.swiper-button-next');

        let pagination = el.querySelector('.swiper-pagination');

        let args = {
            spaceBetween: 0,
            slidesPerView: 1,
            speed: 400,
            loop: true,
            fadeEffect: { crossFade: true },
            effect: "fade",
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            navigation: 
            {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },
            // custom pagination
            pagination: {
                el: pagination,
                clickable: true,
                renderBullet: function (i, className) 
                {
                return `
                    <button class="${className}">
                        <svg class="progress" width="24" height="24">
                            <circle class="circle-origin" r="12" cx="12" cy="12"></circle>
                        </svg>
                        <span></span>
                    </button>`
                }
            },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                notificationClass: 'swiper-notification'
            },
        };

        new Swiper(el, args);
    })
}



// EXPORT COMPONENTE
//--------------------------------------------------------------------//

export default heroHomepage;

//--------------------------------------------------------------------//